"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return [{
        "type": "paragraph_open",
        "tag": "p",
        "attrs": null,
        "map": [0, 1],
        "nesting": 1,
        "level": 0,
        "children": null,
        "content": "",
        "markup": "",
        "info": "",
        "meta": null,
        "block": true,
        "hidden": false
    }, {
        "type": "inline",
        "tag": "",
        "attrs": null,
        "map": [0, 1],
        "nesting": 0,
        "level": 1,
        "children": [{
            "type": "text",
            "tag": "",
            "attrs": null,
            "map": null,
            "nesting": 0,
            "level": 0,
            "children": null,
            "content": " ",
            "markup": "",
            "info": "",
            "meta": null,
            "block": false,
            "hidden": false
        }],
        "content": "⁣",
        "markup": "",
        "info": "",
        "meta": null,
        "block": true,
        "hidden": false
    }, {
        "type": "paragraph_close",
        "tag": "p",
        "attrs": null,
        "map": null,
        "nesting": -1,
        "level": 0,
        "children": null,
        "content": "",
        "markup": "",
        "info": "",
        "meta": null,
        "block": true,
        "hidden": false
    }];
};